export { default } from './CursorAlternateOutline'
